export function EdgeMarkers() {
  return (
    <svg style={{ position: "absolute", width: 0, height: 0 }}>
      <defs>
        <marker id="archi-diamond-filled" viewBox="0 0 20 20" refX="18" refY="10" markerWidth="14" markerHeight="14" orient="auto-start-reverse">
          <polygon points="0,10 10,2 20,10 10,18" fill="#475569" />
        </marker>
        <marker id="archi-diamond-hollow" viewBox="0 0 20 20" refX="18" refY="10" markerWidth="14" markerHeight="14" orient="auto-start-reverse">
          <polygon points="0,10 10,2 20,10 10,18" fill="white" stroke="#475569" strokeWidth="1.5" />
        </marker>
        <marker id="archi-triangle-hollow" viewBox="0 0 20 20" refX="17" refY="10" markerWidth="14" markerHeight="14" orient="auto-start-reverse">
          <polygon points="0,0 20,10 0,20" fill="white" stroke="#475569" strokeWidth="1.5" />
        </marker>
        <marker id="archi-triangle-filled" viewBox="0 0 20 20" refX="17" refY="10" markerWidth="12" markerHeight="12" orient="auto-start-reverse">
          <polygon points="0,0 20,10 0,20" fill="#475569" />
        </marker>
        <marker id="archi-circle-filled" viewBox="0 0 20 20" refX="18" refY="10" markerWidth="10" markerHeight="10" orient="auto-start-reverse">
          <circle cx="10" cy="10" r="7" fill="#475569" />
        </marker>
        <marker id="archi-arrow-filled-sm" viewBox="0 0 20 20" refX="16" refY="10" markerWidth="9" markerHeight="9" orient="auto-start-reverse">
          <polygon points="0,2 16,10 0,18" fill="#475569" />
        </marker>
        <marker id="archi-arrow-open" viewBox="0 0 20 20" refX="16" refY="10" markerWidth="12" markerHeight="12" orient="auto-start-reverse">
          <path d="M2,2 L16,10 L2,18" fill="none" stroke="#475569" strokeWidth="2" />
        </marker>
        <marker id="archi-arrow-open-sm" viewBox="0 0 20 20" refX="16" refY="10" markerWidth="9" markerHeight="9" orient="auto-start-reverse">
          <path d="M4,4 L16,10 L4,16" fill="none" stroke="#475569" strokeWidth="2" />
        </marker>
      </defs>
    </svg>
  );
}
